import { ArrowUpRight } from "lucide-react";

const BULL_LOGO =
    "https://customer-assets.emergentagent.com/job_mad-drinks/artifacts/35o1dtom_ChatGPT%20Image%2020.%206.%202026%2C%2009_50_18.png";

export const ReserveCTA = () => {
    return (
        <section
            data-testid="reserve-cta-section"
            className="relative px-6 sm:px-10 py-24 sm:py-32 overflow-hidden border-t border-white/10"
        >
            {/* Red radial glow */}
            <div
                aria-hidden="true"
                className="pointer-events-none absolute inset-0"
                style={{
                    background:
                        "radial-gradient(ellipse at center, rgba(217,28,28,0.18) 0%, transparent 60%)",
                }}
            />

            <img
                src={BULL_LOGO}
                alt=""
                aria-hidden="true"
                className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] opacity-[0.06] pointer-events-none select-none"
            />

            <div className="relative max-w-[1100px] mx-auto text-center">
                <div className="text-[11px] uppercase tracking-[0.3em] text-[#D91C1C] mb-6">
                    Posledná zastávka
                </div>

                <h2
                    data-testid="reserve-heading"
                    className="font-display uppercase text-5xl sm:text-7xl lg:text-8xl tracking-tighter leading-[0.9] text-white"
                >
                    Vydanie{" "}
                    <span className="text-[#D91C1C]">nie je isté.</span>
                </h2>

                <p
                    data-testid="reserve-tagline"
                    className="mt-8 text-lg sm:text-xl text-white/70 max-w-2xl mx-auto leading-relaxed"
                >
                    Možno bude. Možno nie. Ak ťa to ťahá, napíš nám —
                    dozvieš sa medzi prvými, keď (a či) vyjde ďalšia várka.
                </p>

                <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
                    <a
                        href="mailto:maddrinksss@gmail.com?subject=MAD%20·%20Mám%20záujem&body=Ahoj%2C%0A%0AZaujíma%20ma%20MAD%20Edícia%201.0.%0A%0AMeno%3A%20%0AMesto%3A%20%0A%0AVďaka!"
                        data-testid="reserve-cta-button"
                        className="group inline-flex items-center gap-3 bg-[#D91C1C] hover:bg-white hover:text-black text-white px-10 py-6 text-sm uppercase tracking-[0.25em] font-bold transition-all duration-300 shadow-[0_0_60px_rgba(217,28,28,0.5)] hover:shadow-[0_0_80px_rgba(255,255,255,0.3)]"
                    >
                        Napíš nám
                        <ArrowUpRight
                            size={20}
                            className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"
                        />
                    </a>
                    <a
                        href="https://instagram.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="reserve-cta-instagram"
                        className="inline-flex items-center gap-3 border border-white/20 hover:border-white text-white px-10 py-6 text-sm uppercase tracking-[0.25em] font-bold transition-colors"
                    >
                        Sleduj na Instagrame
                    </a>
                </div>

                <div className="mt-10 text-[11px] uppercase tracking-[0.25em] text-white/40">
                    Bez sľubov · Bez záruk · Iba MAD
                </div>
            </div>
        </section>
    );
};
